export enum GlobalCommunityLoveRankingActionTypes {
  FETCHING = 'community-love-ranking/FETCHING',
  SUCCESS = 'community-love-ranking/RECEIVED ',
  ERROR = 'community-love-ranking/FETCH-ERROR',
}
